module.exports = __webpack_public_path__ + "img/233e76a6d717ed10e0b4ac09b66716f3.png";